import { getCurrentEnv } from 'helpers/getCurrentEnv'

import { ApiService } from 'services/api.service'
import { Events } from 'services/eventLogger.service'

import { CurrentEnvironment, RequestMethod } from 'root-constants'

const btoaAuthCredentialsProd =
  'cHJvZC1mYWNlLXlvZ2Etd3Nob29rc3VzZXI6WXFCNH1tYVJvMQ=='
const btoaAuthCredentialsDev =
  'ZGV2LWZhY2UteW9nYS13c2hvb2tzdXNlcjptWUpTbWdtM3Vn'

export class EventsApi {
  private readonly api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  async sendEvent(
    event: Events,
    eventProperty: Record<string, any>,
    callback?: () => void,
  ): Promise<void> {
    const options = {
      method: RequestMethod.POST,
      headers: new Headers({
        Authorization: `Basic ${this.getBtoaAuthCredentials()}`,
      }),
      body: { event, ...eventProperty },
    }
    await this.api.makeRequest<never>('v1/events/landing', options)

    callback && callback()
  }

  private getBtoaAuthCredentials = (): string =>
    getCurrentEnv() === CurrentEnvironment.PROD
      ? btoaAuthCredentialsProd
      : btoaAuthCredentialsDev
}
